import Cribbage from './Cribbage.js'
export default class CribbageProxy extends Cribbage {
    constructor(socketClient) {
        super();
        this.socketClient = socketClient;
        this.socketClient.onReceive = this.onReceive.bind(this);
        this.level = "Online";
        //do a full sync
        this.action("fullData", null, null);
    }
    onReceive(command, value) {
        if (command === "event") {
            this.sendEvent(value.event, value.value, value.player);
        }
        if (command === "delta") {
            this.patch(value);
        }
        if (command === "data") {
            this.updateData(value);
            this.sendEvent("data", null, null);
        }
    }
    //override: user actions
    action(command, value, player) {
        if (this.socketClient) {
            this.socketClient.action(command, value, player);
        }
    }
    destroy() {
        if (this.socketClient)
            this.socketClient.onReceive = null;

        this.socketClient = null;
        super.destroy();
    }
}




